import { render, staticRenderFns } from "./AppVehiclesDataTable.vue?vue&type=template&id=1ca7efa4&scoped=true&"
import script from "./AppVehiclesDataTable.vue?vue&type=script&lang=js&"
export * from "./AppVehiclesDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AppVehiclesDataTable.vue?vue&type=style&index=0&id=1ca7efa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7efa4",
  null
  
)

export default component.exports